<template>
    <div class="m-login" v-bind:style="{height:heightB+'px'}">
        <div class="m-logo">
            <i class="fa fa-stethoscope" aria-hidden="true"></i>
        </div>
        <h1>广元市第四人民医院</h1>
        <h2>CARE FOR YOU</h2>
        <div class="m-login-form-bg">
            <div class="m-login-form">
                <van-cell-group class="m-form-input">
                    <van-field v-model="form.name" placeholder="请输入您的姓名" clearable/>
                </van-cell-group>
                <van-cell-group class="m-form-input">
                    <van-field v-model="form.id" placeholder="请输入您的身份证号码" clearable/>
                </van-cell-group>
                <van-cell-group class="m-form-input">
                    <van-field v-model="form.phone" placeholder="请输入手机号码" type="tel" clearable>
                        <van-button slot="button" size="small" v-if="countDown <= 0" type="info" @click="checkEmpiUser()">发送验证码</van-button>
                        <van-button slot="button" size="small" v-if="countDown > 0">{{countDown}}s后再次发送</van-button>
                    </van-field>
                </van-cell-group>
                <van-cell-group class="m-form-input">
                    <van-field v-model="form.verificationCode" placeholder="请输入5位短信验证码" type="number" clearable/>
                </van-cell-group>
                <van-cell-group class="m-form-input">
                    <van-button size="large" type="info" @click="loginSubmit">登录</van-button>
                </van-cell-group>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">

    //import {sendMessageCode} from '@/api/messageApi.js'
    import {getEmpiUser} from '@/api/empiApi.js'
    import {randomNum} from '@/api/helper/index.js'
    let moment = require("moment");
    import axios from 'axios'

    export default{
        data(){
            return {
                heightB:document.documentElement.clientHeight,
                form:{
                    name:'',
                    id:'',
                    phone:'',
                    verificationCode:''
                },
                countDown:0,
            }
        },
        methods:{
            checkEmpiUser(){
                if(!this.form.name){
                    this.$message({message: '请输入您的姓名', type: 'warning'});return false;
                }
                if(!this.form.id){
                    this.$message({message: '请输入您的身份证号', type: 'warning'});return false;
                }
                if(!this.form.phone){
                    this.$message({message: '请输入您预留的手机号码', type: 'warning'});return false;
                }
                getEmpiUser({
                    page:0,
                    size:10,
                    specification:JSON.stringify({
                        XM:this.form.name,
                        SFZHM:this.form.id
                    })
                }).then(res=>{
                    let title = '';
                    if(res && res.list.length > 0){
                        if(res.list[0].XM == this.form.name && res.list[0].SFZHM == this.form.id){
                            if(res.list[0].SJHM == this.form.phone){
                                this.$cookies.set('CHECK_EMPI', JSON.stringify({
                                    mdmId:res.list[0].mdmId ? res.list[0].mdmId : '',
                                    esId:res.list[0].esId ? res.list[0].esId : '',
                                    xm:res.list[0].XM ? res.list[0].XM : '',
                                    csd:res.list[0].CSD ? res.list[0].CSD : '',
                                    lxr:res.list[0].LXRXM ? res.list[0].LXRXM : '',
                                    lxrdh:res.list[0].LXRDH ? res.list[0].LXRDH : '',
                                }),{expires:1})
                                this.sendVerification(this.form.phone)
                            }else{
                                title = '您的预留手机号码信息有误，请至医院柜台补全信息后登陆'
                            }
                        }else{
                            title = '您的信息有误，请至医院柜台补全信息后登陆'
                        }
                    }else{
                        title = '未查询到您的就医信息'
                    }
                    if(title){
                        this.$dialog.alert({
                            message: title
                        });
//                        this.$alert(title, '提示', {
//                            confirmButtonText: '确定',
//                            callback: action => {}
//                        });
                    }
                }).catch(err=>{
                    this.$message.error('验证失败，请稍后再试')
                })
            },
            sendVerification(phone){
                let code = randomNum(false,5)
                let time  = moment(new Date()).format('YYYYMMDDhmmss')+code
                this.makeVerification(phone,code,time)
                let xml = '<?xml version="1.0" encoding="UTF-8"?><message><key>8CEB6493-E499-D0E5-2015-7D19AE999FBD</key><msgContent>&lt;?xml version="1.0" encoding="UTF-8"?&gt;&lt;!--调用时间 '+time+'--&gt;&lt;json&gt;{"funcode":"100122","args":{"phone":"'+phone+'","tcontent":"【广元市第四人民医院】您当前正在使用患者门户平台，登录验证码是：'+code+'，如非本人操作，请忽略此短信。"}}&lt;/json&gt;</msgContent> <msgCode>SendMessage</msgCode><msgVersion>1</msgVersion></message>';
                var config = {
                    headers: {'Content-Type': 'application/xml'}
                };
                axios.post('/hie_api/hie/services/hieService/msgTransfer', xml, config).then(res=>{
                    if(res.data.errorCode || res.data.errorInfo){
                        this.$message.error(res.data.errorInfo)
                    }else{
                        let result = res.data.syncResult ? JSON.parse(res.data.syncResult) : '';
                        if(result && result.code == 0){
                            this.countDown = 60
                            var m = setInterval(()=>{
                                this.countDown--;
                                if(this.countDown==0){
                                    clearInterval(m);
                                    this.countDown = 0;
                                }
                            },1000);
                            this.$message({message:'短信发送成功',type:'success'});
                        }else{
                            this.$message.error('验证码发送失败，请稍后再试')
                        }
                    }
                }).catch(err=>{
                    this.$message.error('验证码发送失败，请稍后再试')
                })
            },
            makeVerification(phone,code,time){
                //将数据组合成对象，放入到cookie中，验证时判断手机号合时间参数
                this.$cookies.set('LOGIN_VERIFICATION', JSON.stringify({
                    phone:phone,
                    code:code,
                    time:time
                }),{expires:1})
            },
            loginSubmit(){
                if(!this.form.name){
                    this.$message({message: '请输入您的姓名', type: 'warning'});return false;
                }
                if(!this.form.id){
                    this.$message({message: '请输入您的身份证号', type: 'warning'});return false;
                }
                if(!this.form.phone){
                    this.$message({message: '请输入您预留的手机号码', type: 'warning'});return false;
                }
                if(!this.form.verificationCode || this.form.verificationCode.length != 5){
                    this.$message({message: '请输入5位手机短信验证码', type: 'warning'});return false;
                }
                let verification = this.$cookies.get('LOGIN_VERIFICATION')
                if(!verification || !verification.phone || !verification.code){
                    this.$message({message: '验证码验证失败', type: 'warning'});return false;
                }
                if(this.form.phone != verification.phone || this.form.verificationCode != verification.code ){
                    this.$message({message: '验证码不匹配', type: 'warning'});return false;
                }
                let empi = this.$cookies.get('CHECK_EMPI')
                this.$cookies.set('LOGIN_INFO', JSON.stringify({
                    mdmId:empi.mdmId,
                    esId:empi.esId,
                    xm:empi.xm,
                    csd:empi.csd,
                    lxr:empi.lxr,
                    lxrdh:empi.lxrdh,
                }),{expires:1})
                this.$cookies.remove('CHECK_EMPI')
                this.$cookies.remove('LOGIN_VERIFICATION')
                this.$router.push({ name: 'jyjl'})
            }
        }
    }
</script>
<style scoped>
    .m-login{
        min-height: 0px;
        height:auto;
        background:url('../../assets/image/bg1.jpg') no-repeat center center;
        background-size: cover;
        -webkit-background-size: cover;
    }
    .m-logo{
        padding-top:40px;
        text-align: center;
        font-size: 3em;
        color: #fff;
    }
    h1{
        margin:0;
        font-size: 20px;
        color: #fff;
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 2px;
        font-weight: 700;
    }
    h2{
        margin-top:10px;
        font-size: 18px;
        color: #fff;
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 1.5px;
        font-weight: 700;
    }
    .m-login-form-bg{
        width:100%;
        background: rgba(0, 0, 0, 0.54);
        padding-top: 20px;
        margin-top: 40px;
        padding-bottom: 20px;
    }
    .m-login-form{
        width:80%;
        background: #000;
        margin:0 auto;
        position: relative;
        padding:5px;
    }
    .m-form-input{
        margin:15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile/login.vue